/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_DescInputs */

const en_ui_settings_about_desc = /** @type {(inputs: Ui_Settings_About_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault is a local-first fitness session analyzer. All your data stays on your device — nothing is sent to any server. If you encounter a bug or have a feature request, head over to GitHub.`)
};

const de_ui_settings_about_desc = /** @type {(inputs: Ui_Settings_About_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault analysiert deine Trainingseinheiten direkt im Browser. Alle Daten bleiben auf deinem Gerät — nichts verlässt dein Gerät. Fehler gefunden oder Feature-Idee? Ab zum GitHub-Repo.`)
};

/**
* | output |
* | --- |
* | "PaceVault is a local-first fitness session analyzer. All your data stays on your device — nothing is sent to any server. If you encounter a bug or have a fea..." |
*
* @param {Ui_Settings_About_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_desc = /** @type {((inputs?: Ui_Settings_About_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_desc(inputs)
	return de_ui_settings_about_desc(inputs)
});